import { joinPaths, createURLDescriptor } from './URLTools';
import { NotFoundError } from './Errors';
export function createChunk(type, request, details) {
    return Object.assign({
        type: type,
        request: request,
        url: createURLDescriptor({
            pathname: request.mountpath,
            query: request.query,
        }),
    }, details);
}
export function createNotFoundChunk(request) {
    var fullPathname = joinPaths(request.mountpath, request.path);
    return {
        type: 'error',
        request: request,
        url: createURLDescriptor({
            pathname: fullPathname,
            query: request.query,
        }),
        error: new NotFoundError(fullPathname),
    };
}
//# sourceMappingURL=Chunks.js.map